import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlusCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	fill: "none",
	viewBox: "0 0 25 25",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.5,
			cy: 12.5,
			r: 11.979,
			stroke: "currentColor",
			strokeWidth: 1.0417
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m17.5 11.887v1.066h-10v-1.066zm-4.4388-4.3868v10h-1.2024v-10z",
			fill: "currentColor",
			strokeWidth: .99559
		})
	]
});
const ForwardRef = forwardRef(SvgPlusCircle);
export { ForwardRef as ReactComponent };
